<template>
  <div class="content">
    <h1><span>{{ neighborhoodInfo.name }}</span> collisions since <span>January 1, 2006</span></h1>

    <div class="l-grid l-grid-large">
      <MonthlyCollisions :getters="{
                            average: 'neighborhoodView/monthlyCollisions/average',
                            monthlyCollisions: 'neighborhoodView/monthlyCollisions/get',
                            total: 'neighborhoodView/monthlyCollisions/total'
                          }"></MonthlyCollisions>
      <DamageCosts :getter="'neighborhoodView/damageCosts/get'"
                   :title="'Economic costs'"
                   :bar-color="this.$store.getters.green.light.a"></DamageCosts>
    </div>

    <div class="l-grid l-grid-small">
      <WhoRank :getters="{rankings: 'neighborhoodView/whoRank/get'}"></WhoRank>
      <SeverityRank :getters="{rankings: 'neighborhoodView/severityRank/get'}"></SeverityRank>
      <Weather :card-color="'blue'"
               :card-icon="'cloud'"
               :getter="'neighborhoodView/weather/get'"
               :table-color="'blue'"
               :title="'Weather'"
               :bar-color="this.$store.getters.blue.light.a"
               :chart-height="380"
               :x-min-axes-rotation="75"></Weather>

      <RoadConditions :card-color="'orange'"
                      :getter="'neighborhoodView/roadConditions/get'"
                      :table-color="'orange'"
                      :title="'Road conditions'"
                      :bar-color="this.$store.getters.orange.light.a"></RoadConditions>

      <LightConditions :card-color="'yellow'"
                       :card-icon="'wb_incandescent'"
                       :getter="'neighborhoodView/lightConditions/get'"
                       :table-color="'yellow'"
                       :title="'Light conditions'"
                       :bar-color="this.$store.getters.yellow.light.a"></LightConditions>
      
      <CollisionTypes :card-color="'purple'"
                      :card-icon="'call_split'"
                      :getter="'neighborhoodView/collisionTypes/get'"
                      :table-color="'purple'"
                      :title="'Collision types'"
                      :bar-color="this.$store.getters.purple.light.a"></CollisionTypes>
      
      <JunctionTypes :card-color="'teal'"
                     :getter="'neighborhoodView/junctionTypes/get'"
                     :table-color="'teal'"
                     :title="'Junction types'"
                     :bar-color="this.$store.getters.teal.light.b"
                     :chart-height="520"
                     :x-min-axes-rotation="80"></JunctionTypes>
      
      <AddressTypes :card-color="'teal'"
                    :getter="'neighborhoodView/addressTypes/get'"
                    :table-color="'teal'"
                    :title="'Address types'"
                    :bar-color="this.$store.getters.teal.light.b"></AddressTypes>
    </div>

    <SeattleCityCouncilInformation></SeattleCityCouncilInformation>

    <Geo :multipolygons="multipolygons"></Geo>
  </div>
</template>

<script>
import BarChartWithTable from '@/components/barCharts/BarChartWithTable'
import DamageCosts from '@/components/barCharts/DamageCosts'

import SeverityRank from '@/components/tables/SeverityRank'
import WhoRank from '@/components/tables/WhoRank'
import MonthlyCollisions from '@/components/lineCharts/MonthlyCollisions'

import SeattleCityCouncilInformation from '@/components/SeattleCityCouncilInformation'
import Geo from '@/components/Geo'

export default {
  name: 'neighborhood',

  components: {
    'AddressTypes': BarChartWithTable,
    'JunctionTypes': BarChartWithTable,
    'CollisionTypes': BarChartWithTable,
    'LightConditions': BarChartWithTable,
    'RoadConditions': BarChartWithTable,
    'Weather': BarChartWithTable,
    'DamageCosts': DamageCosts,
    'SeverityRank': SeverityRank,
    'WhoRank': WhoRank,
    'MonthlyCollisions': MonthlyCollisions,
    'Geo': Geo,
    'SeattleCityCouncilInformation': SeattleCityCouncilInformation
  },

  mounted: function () {
    this.$store.dispatch('neighborhoodView/resetResults')
    this.$store.dispatch('neighborhoodView/setFilters')
    this.$store.dispatch('neighborhoodView/fetchAll', {id: this.$store.state.route.params.id, filters: this.filters})
  },

  computed: {
    filters () {
      return this.$store.getters['neighborhoodView/filters']
    },

    neighborhoodInfo () {
      return this.$store.getters['neighborhoodView/pageInfo/get']
    },

    multipolygons () {
      if (typeof this.neighborhoodInfo.multipolygon !== 'undefined') {
        return [{
          data: this.neighborhoodInfo.multipolygon,
          options: {
            color: this.$store.getters.teal.dark.a,
            interactive: false
          }
        }]
      }
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('neighborhoodView/resetResults')
      this.$store.dispatch('neighborhoodView/fetchAll', {slug: this.$store.state.route.params.slug, filters: this.filters})
    }
  },

  beforeRouteLeave (to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full')
    next()
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/geo.scss";
</style>



// WEBPACK FOOTER //
// Neighborhood.vue?38423876